<template>
      <div id="header" :class="scroll">
            <div class="grid-container">
                  <div class="grid-x grid-padding-x align-justify text-right align-middle">
                        <div class="cell shrink">
                              <div v-if="$route.path==='/'">
                                    <a href="#hpn-app" v-smooth-scroll><img alt="Anthem National Accounts" src="img/anthem-bc-logo.png" width="125"/></a>
                              </div>
                              <div v-else>
                                    <router-link to="/"><img alt="Anthem National Accounts" src="img/anthem-bc-logo.png" width="125"/></router-link>
                              </div>
                        </div>
                  </div>
            </div>
      </div>
</template>

<script>
      export default {
            name: "TopBar",
            data() {
                  return{
                        scroll: ""
                  }
            },
            created() {
                  window.addEventListener('scroll', this.scrollDown)
            },
            destroyed() {
                  window.removeEventListener('scroll', this.scrollDown)
            },
            methods: {
                  scrollDown(){
                        let width = window.innerWidth;
                        let currentScroll = window.pageYOffset;
                        if(width <= 640){
                              currentScroll = window.pageYOffset + 300;
                        }
                        if (currentScroll >= 120) {
                              this.scroll = "scroll-down"
                        } 
                        else {
                              this.scroll = ""
                        }
                  }
            }
      };
</script>

<style lang="scss">
      #header{
            background-color: rgba(120, 179, 224, 0.4); // NEW STYLE
            padding-top:14px;
            padding-bottom: 14px;
            /*position: fixed;
            left: 0;
            right: 0;
            top: 0;
            z-index: 5;*/
            transition: all 0.2s ease-in-out 0s;

            .button.anthem-btn{
                  padding: .5em 1em .4em;
                  font-size: 1.125rem;
            }
            .top-btn{
                  opacity: 0;
            }
            &.scroll-down {
                  background-color: rgba(120, 179, 224, 0.7); // NEW STYLE
            }
      }
</style>
